

































import Vue from "vue";

import RestClient, { RestError } from "../../../RestClient";

import DateFormatter from "../../../shared/DateFormatter";
import Loading from "../../general/Loading.vue";

import ClientJson from "../../../shared/ClientJson";

export default Vue.extend({
  name: "ClientsLogin",
  components: {
    Loading,
  },
  props: {},
  data() {
    return {
      RestClient: RestClient,
      DateFormatter: DateFormatter,
      user: "" as string,
      password: "" as string,
      loggedIn: null as ClientJson | null,
      loadingGeneral: false as boolean,
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    init() {},

    async login() {
      this.loadingGeneral = true;

      try {
        this.loggedIn = await this.RestClient.loginClient(this.user, this.password);

        this.$emit("loggingIn", this.loggedIn, this.password);
        this.loadingGeneral = false;
      } catch (e) {
        this.loadingGeneral = false;
        alert(e.message);
      }
    },

    logout() {
      window.sessionStorage.clear();
      window.localStorage.clear();
      location.reload();
    },
  },

  watch: {},

  computed: {},
});
